<script lang="ts">
  import { domain } from '$lib/config/nucamp.client.json';

  export let metatags: {
    title: string;
    metadescription: string;
    image: string;
    type: string;
    slug: string;
    user?: {
      referral: { code: string};
    };
    geo?: {
      position: string;
      placename: string;
      region: string;
    };
    canonical?: string;
    robots?: string;
  }
</script>

<svelte:head>
  <title>{metatags.title}</title>
  <meta name="description" content={metatags.metadescription} />
  <!-- Standard OG tags -->
  <meta property="og:title" content={metatags.title} />
  <meta property="og:description" content={metatags.metadescription} />
  <meta property="og:image" content={metatags.image} />
  <meta property="og:site_name" content="Nucamp" />
  <meta property="og:url" content={`${domain}${metatags.slug}`} />
  <meta property="og:type" content={metatags.type ?? "website"} />
  <!-- Twitter Card tags -->
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content={metatags.title} />
  <meta name="twitter:site" content="@nucampcodingbc" />
  <meta name="twitter:description" content={metatags.metadescription} />
  <meta name="twitter:image" content={metatags.image} />
  <!-- Geo tags -->
  {#if metatags.geo}
    <meta name="geo.position" content={metatags.geo.position} />
    <meta name="geo.placename" content={metatags.geo.placename} />
    <meta name="geo.region" content={metatags.geo.region} />
  {/if}
  <!-- Canonical -->
  <link rel="canonical" href={`${domain}${metatags.canonical}`} />
  <!-- Robots -->
  {#if metatags.robots}
    <meta name="robots" content={metatags.robots} />
  {:else}
    <meta name="robots" content="index, follow" />
  {/if}
</svelte:head>
